import type { AdminQuoteDetail } from '@repo/api-contracts';
import { ArrowLeft } from 'lucide-react';
import type { ReactElement } from 'react';
import { activeQuoteWarnings } from '@/entities/quote';
import { Button, PageHeader } from '@/shared/ui';
import { QuoteStatusList } from './quote-status-list';

export interface QuoteDetailHeaderProps {
  /** 받은 견적 — 받기 전·실패·잘못된 주소면 null 이고 제목은 "견적 상세"다. */
  readonly quote: Pick<AdminQuoteDetail, 'quoteNumber' | 'status' | 'warnings'> | null;
  /** "목록으로" — 페이지가 견적 목록으로 옮긴다. */
  readonly onBack: () => void;
}

/** 견적 상세 머리말 — 견적 번호·상태(경고 포함) 배지·목록으로 버튼. 주문 상세 머리말과 같은 자리·크기. */
export const QuoteDetailHeader = ({ quote, onBack }: QuoteDetailHeaderProps): ReactElement => (
  <PageHeader
    title={quote ? `견적 ${quote.quoteNumber}` : '견적 상세'}
    description={
      quote ? (
        <QuoteStatusList status={quote.status} warnings={activeQuoteWarnings(quote.warnings)} />
      ) : undefined
    }
    actions={
      <Button type="button" variant="outline" className="h-10 px-5" onClick={onBack}>
        <ArrowLeft aria-hidden="true" />
        목록으로
      </Button>
    }
  />
);
